/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import Avatar from 'components/base/Avatar';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import { Modal } from 'react-bootstrap';
import PageLoader from '../animate-component/PageLoader';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;

    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const CreateModal = ({
  show,
  handleClose,
  loading,
  loadingText,
  children,
  heading,
  icon,
  handleSubmit,
  formProps,
  size = ''
}) => {
  return (
    <>
      <CustomModal
        size={size}
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          className="border-0 position-relative pb-0 end-0 dark__text-white"
          closeButton={!loading}
        >
          <div className="d-flex align-items-center mb-2">
            {icon ? (
              <Avatar size="xl" variant="name" className="me-2">
                <Icon icon={icon} fontSize="18px" />
              </Avatar>
            ) : null}
            {heading}
          </div>
        </Modal.Header>
        <form onSubmit={handleSubmit} {...formProps}>
          <Modal.Body className="pt-2">{children}</Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              variant="phoenix-secondary"
              disabled={loading}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="phoenix-success"
              disabled={loading}
              type={'submit'}
            >
              {loading ? 'Creating...' : 'Create'}
            </Button>
          </Modal.Footer>
        </form>

        <PageLoader loading={loading} loadingMessage={loadingText} />
      </CustomModal>
    </>
  );
};

export default CreateModal;
